import { render, staticRenderFns } from "./Oscopy.vue?vue&type=template&id=4b130163"
import script from "./Oscopy.vue?vue&type=script&lang=js"
export * from "./Oscopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports